import { render } from "./DeleteAccount.vue?vue&type=template&id=6ec7b693&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"

import "./DeleteAccount.vue?vue&type=style&index=0&id=6ec7b693&scoped=true&lang=css"
import "./DeleteAccount.vue?vue&type=style&index=1&id=6ec7b693&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec7b693"]])

export default __exports__